import React from "react";
import styled from "styled-components";
import ProgressBar from "./ProgressBar";

const MoodListContainer = styled.div`
    width: 100%;
    min-width: 0;
    padding: 0.25rem 0;
    box-sizing: border-box;
`;

const ProgressContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
`;

const MoodItem = styled.div`
    display: grid;
    grid-template-columns: 2rem minmax(0, 1fr);
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.65rem;
    font: normal normal bold 25px / 33px Manrope;
    min-width: 0;
`;

const MoodLabel = styled.div`
    letter-spacing: 0px;
    font-family: Manrope;
    font-size: .75rem;
    line-height: normal; 
    font-weight: 500;
    color: #171A22;
    overflow-wrap: anywhere;
`;

const MoodPercentageLabel = styled.div`
    min-width: 2.2rem;
    letter-spacing: 0px;
    font-family: Manrope;
    font-size: .75rem;
    line-height: normal;
    text-align: right;
    color: #000000;
    font-weight: 600;
`;

const MoodDistributionList = ({ moodData }) => {
    const totalCheckins = moodData.reduce((acc, item) => acc + item.count, 0);
    const maxCount = Math.max(...moodData.map(mood => mood.count));
    const moodEmoji = {
        Happy: "😁",
        Content: "😊",
        Neutral: "😐",
        Sad: "😔",
        Unhappy: "😢",
        Tired: "😴",
        Stressed: "😬",
        Sick: "🤒",
    };
    return (
        <MoodListContainer>
            {moodData && moodData.map(mood => {
                const progressBarMoodCount = mood.count === 0 ? 0 : (mood.count / maxCount);
                const numberMoodCount = mood.count === 0 ? 0 : (mood.count / totalCheckins);
                return (
                    <MoodItem key={mood.moodType}>
                        <div style={{ fontSize: "1.65rem", lineHeight: 1 }}>
                            {moodEmoji[mood.moodType]}
                        </div>
                        <div style={{ minWidth: 0 }}>
                            <MoodLabel>{mood.moodType}</MoodLabel>
                            <ProgressContainer>
                                <ProgressBar value={ progressBarMoodCount * 100} moodType={mood.moodType} />
                                <MoodPercentageLabel>
                                    {Number(numberMoodCount * 100).toFixed(0)}%
                                </MoodPercentageLabel>
                            </ProgressContainer>
                        </div>
                    </MoodItem>
                );
            })}
        </MoodListContainer>
    );
};

export default MoodDistributionList;
